import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
interface HeaderProps {
  onOpenModal: () => void;
}
export function Header({
  onOpenModal
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 h-[60px] transition-all duration-300 ${isScrolled ? 'bg-brand-bg/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-128">
      <div className="w-full h-full px-4 md:px-6 flex items-center justify-between" data-id="element-129">
        <a href="#" className="flex items-center" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/3CBqbMNS62YcqC8fVCFkjB/Group-35581-1.svg" alt="Be Clinical" className="h-10 md:h-14 w-auto" data-id="element-131" />
        </a>

        <Button className="!min-h-[36px] !py-1.5 !px-5 !text-xs !w-auto" onClick={onOpenModal} data-id="element-132">
          Book Now
        </Button>
      </div>
    </header>;
}